import * as yup from 'yup';

export const committeeMemberPersonSchema = yup.object({
    personId: yup.number().nullable().required('Member is required'),
    dateAppointed: yup.date().nullable().required('Date Appointed is required'),
    isActive: yup.boolean().nullable().required('Status is required'),
    dateResigned: yup.date().when('isActive', {
        is: (isActive: boolean) => isActive === false,
        then: yup.date().typeError("Date Resigned is required").required("Date Resigned is required"),
        otherwise: yup.date().nullable()
    })
})